module.exports = __webpack_public_path__ + "img/25_31.1307d4ed.png";